import {
	getNumber,
	getString,
	getDate,
	getBoolean,
} from "../../../../../utils/mappersUtils/object";
import { isObject } from "../../../../../utils/mappersUtils/guards";

export const mapMessageTemplateDetail = (template) => {
	if (!isObject(template)) {
		return null;
	}

	return {
		id: getNumber(template, "id"),
		useCaseId: getNumber(template, "useCaseId"),
		objectType: getNumber(template, "useCase.objectType", 1),
		messageType: getNumber(template, "useCase.messageType", 1),
		useCase: {
			id: getNumber(template, "useCase.id", 0),
			useCase: getNumber(template, "useCase.useCase"),
			description: getString(template, "useCase.description", ""),
			messageType: getNumber(template, "useCase.messageType", 1),
			objectType: getNumber(template, "useCase.objectType", 1),
		},
		language: getString(template, "language", ""),
		outletId: getNumber(template, "outletId", null),
		country: {
			id: getNumber(template, "country.id", null),
			description: getString(template, "country.description", ""),
		},
		dealerGroupId: getNumber(template, "dealerGroupId", null),
		brand: {
			id: getNumber(template, "brand.id", 0),
			description: getString(template, "brand.description", ""),
		},
		body: getString(template, "body", ""),
		modified: {
			on: getString(template, "modifiedOn") ? getDate(template, "modifiedOn") : "",
			byId: getNumber(template, "modifiedById", null),
			byName: getString(template, "modifiedByName", ""),
			avatar: getString(template, "modifiedByAvatar", ""),
			byFirstName:
				getString(template, "modifiedByName", "").split(" ")[0] || "",
			byLastName:
				getString(template, "modifiedByName", "")
					.split(" ")
					.slice(1)
					.join(" ") || "",
		},
		isWaitsOnPremiseDependent: getBoolean(template, "isWaitsOnPremiseDependent", false),
		isWaitsOnPremise: getBoolean(template, "isWaitsOnPremise", false),
	};
};
